import { MapperBase } from '../../utilities/mapper-base';
import { UploadBatchResource } from '../resource/upload-batch.resource';
import { Upload, UploadBatchValidationStatus } from '../ui/upload.model';

export class UploadBatchResourceToUploadMapper extends MapperBase<UploadBatchResource, Upload> {
		private batchTypeReportMap = new Map([
			['cbe6f05f-ea98-4919-babd-40594884a6f4', 'native-upload-validation-report'],
			['9a8eb8be-29ed-45d9-86e9-3a911ed3f0f3', 'production-upload-validation-report']]);

	map(source: UploadBatchResource): Upload {
		const dest = new Upload();
		dest.id = source.uploadBatchId;
		dest.typeId = source.uploadBatchTypeId;
		dest.title = source.batchTitle;
		dest.comments = source.batchComments;
		dest.caseId = source.caseId;
		dest.userId = source.userId;
		dest.username = source.user?.userName;
		dest.custodianId = source.custodianId;
		dest.custodianName = source.custodian?.name;
		dest.isOcrOnServer = source.isOcrOnServer;
		dest.isUploadToAmazonS3 = source.isUploadToAmazonS3;
		dest.docSource = source.docSource;
		dest.utcOffset = source.utcOffset;
		dest.uploadDate = source.uploadBatchDate;
		dest.isCreateFolders = source.isCreateFolders;
		dest.lifeCycle = source.lifeCycle;
		dest.validationReportRoute = this.batchTypeReportMap.has(source.uploadBatchTypeId) ?
			`/case/${this.batchTypeReportMap.get(source.uploadBatchTypeId)}/${source.uploadBatchId}` : '/case/uploads';
		dest.docCount = source.docCount;
		dest.validationStatus = UploadBatchValidationStatus[source.validationStatus];
		return dest;
	}
}


